




















































































































import { Component, Vue ,Prop} from "vue-property-decorator";
import AddTransfer from "./modals/addTransfer.vue";
import UpdateTransfer from "./modals/updateTransfer.vue";
import Ajax from '../../../lib/ajax';
import Transfer from "@/store/entities/transfer";
@Component({
  components: { AddTransfer, UpdateTransfer },
})
export default class Transfers extends Vue {
  @Prop()
  transfer!: any;
  search: string = "";
  isOpenModal: boolean = false;
  transfers: Transfer[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenUpdateModal: boolean = false;
  selectedItem:any={};
   async getTransfers(){
    var response =  await Ajax.get(
        '/api/services/app/Transfer/GetTransfers'
      );
      this.transfers=response.data.result.items;;
  }

   async created() {
      this.headers= [
          { text: 'Nereden', value: 'from' },
          { text: 'Nereye', value: 'to' },
          { text: 'Km', value: 'km' },
          { text: 'Süre(dk)', value: 'time' },
          { text: 'Araç Tipi', value: 'vehicleType' },
          { text: 'Başlangıç Tarihi', value: 'startDate' },
          { text: 'Bitiş Tarihi', value: 'endDate' },
          { text: 'Kapasite', value: 'capacity' },
          { text: 'Bagaj', value: 'baggage' },
          { text: 'Aktif mi?', value: 'active' },
          { text: 'Fiyat', value: 'price' },
          { text: 'Para Birimi', value: 'currency' },
          { text: "İşlemler", value: "transactions" }

        ],
       
        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Transfer',disabled: true},
          {text: 'Transferler',disabled: true}
      ]
      await this.getTransfers();
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async confirmDelete(item) {
  await this.$swal({
    title: "Satır Silinecetir.",
    text: "İşlemi Devam Ettirmeye Emin misiniz?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Evet",
    cancelButtonText: "Hayır",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await Ajax.delete('/api/services/app/Transfer/DeleteTransfer?input=' + item.id);
        Vue.$toast.success("Silme Başarılı");
        await this.getTransfers();
      } catch (error) {
        // Hata yönetimi burada
        console.error("Silme işlemi sırasında hata oluştu:", error);
      }
    }
  });
}

  openModal() {
    this.isOpenModal = true;
  
  }
  closeModal() {
    this.isOpenModal = false;
    this.getTransfers();
    
  }

  cancelModal() {
    this.isOpenModal = false;
  }

  openUpdateModal(item) {
    this.selectedItem=item;
    this.isOpenUpdateModal = true;
  }
  closeUpdateModal() {
    this.isOpenUpdateModal = false;
    this.getTransfers();
  }

  cancelUpdateModal() {
    this.isOpenUpdateModal = false;
  }
  
}
